import { render, staticRenderFns } from "./LootPage.vue?vue&type=template&id=6c1311f2&lang=pug&"
import script from "./LootPage.vue?vue&type=script&lang=ts&"
export * from "./LootPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports